import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  sportsGrounds: [],
  selectedGround: null,
  selectedSlots: [],
  selectedDate: null,
  totalPrice: 0,
  slotPrice: 0,
  availableSlots: [],
  bookings: [],
  loading: false,
  error: null,
  selectedSport: null,
  selectedDuration: null,
  selectedSportPrice: 0,
  sportsPricing: {},
  bookedData: null,
  categoryId: null
};

const sportsSlice = createSlice({
  name: 'sports',
  initialState,
  reducers: {
    fetchSportsGroundsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchSportsGroundsSuccess: (state, action) => {
      state.sportsGrounds = action.payload;
      state.loading = false;
      state.error = null;
    },
    fetchSportsGroundsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    setSelectedGround: (state, action) => {
      state.selectedGround = action.payload;
    },
    setSelectedSlots: (state, action) => {
      state.selectedSlots = action.payload;
    },
    setSelectedDate: (state, action) => {
      state.selectedDate = action.payload;
    },
    setTotalPrice: (state, action) => {
      state.totalPrice = action.payload;
    },
    setSlotPrice: (state, action) => {
      state.slotPrice = action.payload;
    },
    setSelectedSport: (state, action) => {
      state.selectedSport = action.payload;
    },
    setSelectedDuration: (state, action) => {
      state.selectedDuration = action.payload;
    },
    setSelectedSportPrice: (state, action) => {
      state.selectedSportPrice = action.payload;
    },
    setSportsPricing: (state, action) => {
      state.sportsPricing = action.payload;
    },
    fetchAvailableSlotsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchAvailableSlotsSuccess: (state, action) => {
      state.availableSlots = action.payload;
      state.loading = false;
      state.error = null;
    },
    fetchAvailableSlotsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    createBookingStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    createBookingSuccess: (state, action) => {
      state.bookings.push(action.payload);
      state.loading = false;
      state.error = null;
    },
    createBookingFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchBookingsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchBookingsSuccess: (state, action) => {
      state.bookings = action.payload;
      state.loading = false;
      state.error = null;
    },
    fetchBookingsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearSportsData: (state) => {
      state.sportsGrounds = [];
      state.selectedGround = null;
      state.selectedSlots = [];
      state.selectedDate = null;
      state.totalPrice = 0;
      state.slotPrice = 0;
      state.availableSlots = [];
      state.bookings = [];
      state.loading = false;
      state.error = null;
      // Don't clear categoryId to maintain context across navigation
    },
    setBookedData: (state, action) => {
      state.bookedData = action.payload;
    },
    setCategoryId: (state, action) => {
      state.categoryId = action.payload;
    },
    setSlotData: (state, action) => {
      state.selectedDate = action.payload.selectedDate;
      state.selectedTime = action.payload.selectedTime;
      if (action.payload.selectedSlots) {
        state.selectedSlots = action.payload.selectedSlots;
      }
    },
  },
});

export const {
  fetchSportsGroundsStart,
  fetchSportsGroundsSuccess,
  fetchSportsGroundsFailure,
  setSelectedGround,
  setSelectedSlots,
  setSelectedDate,
  setTotalPrice,
  setSlotPrice,
  setSelectedSport,
  setSelectedDuration,
  setSelectedSportPrice,
  setSportsPricing,
  fetchAvailableSlotsStart,
  fetchAvailableSlotsSuccess,
  fetchAvailableSlotsFailure,
  createBookingStart,
  createBookingSuccess,
  createBookingFailure,
  fetchBookingsStart,
  fetchBookingsSuccess,
  fetchBookingsFailure,
  clearSportsData,
  setBookedData,
  setCategoryId,
  setSlotData,
} = sportsSlice.actions;
export default sportsSlice.reducer; 